module.exports = "/_next/static/images/australiaalt-35cc3063f7990aac8968df99ffb92d2a.svg";